import { CHARACTERS_SLUG } from '~/lib/constants';
// ---- internal imports -----

export function getSelectedCharacterId(state) {
	return state.character.id;
}

export function getSelectedCharacterPower(state) {
	return state.character.power;
}

export function getSelectedCharacterSlug(state) {
	return state.character.slug;
}

export function getCharacter(state) {
	return state.character;
}

export function getCompletionMessage(state) {
	return state.character.completionMsg;
}

export function isGolofinSelected(state) {
	return getSelectedCharacterSlug(state) === CHARACTERS_SLUG.GOLOFIN;
}
